import { CRUDApiService } from "./CRUDApiService";

export class DashboardApiService extends CRUDApiService {
  constructor() {
    super('dashboard');
  }
}
